import React from 'react'
import ContactMe from '../ContactMe/ContactMe'
import ContactUsCover from '../ContactUsCover/ContactUsCover'
import ContactUsInfo from '../ContactUsInfo/ContactUsInfo'
import Header from '../Header/Header'
import './ContactUs.css'

const ContactUs = () => {
  return (
    <div className='contact-us-container'>
       <Header/> 
      <ContactUsCover/>
      <ContactUsInfo/>
      <ContactMe/>
    </div>
  )
}

export default ContactUs
